import React, { useState, useEffect, useContext } from 'react';
import './ParticularProject.scss';
import { Link } from 'react-router-dom';

import { DataContext } from '../../Contexts/DataContext';

import { motion, AnimatePresence } from 'framer-motion';
import {
  fadeinTop,
  pageTransitions,
  fadeinslow,
  fadeinfast,
} from '../../animations';
import { useInView, InView } from 'react-intersection-observer';
import { useHistory } from 'react-router-dom';

import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { Carousel } from 'react-responsive-carousel';

import demoPic from '../../Assets/Icons/demoPic.jpg';
import backButton from '../../Assets/Icons/back.png';
import github from '../../Assets/Icons/github.png';
import demo from '../../Assets/Icons/demo.png';

import { projectList } from '../Projects/ProjectList';
const ParticularProject = (props) => {
  const { projects, skills } = useContext(DataContext);

  const [project, setProject] = useState(null);
  const history = useHistory();

  useEffect(() => {
    if (projects) setProject(projects[props.match.params.id]);
  }, [projects]);

  const [top, setTop] = useState(0);
  const handleScroll = (e) => {
    setTop(e.target.scrollTop);
  };
  useEffect(() => {
    if (top > 170) props.setDarkenNavbar(true);
    else props.setDarkenNavbar(false);
  }, [top]);

  return (
    <>
      {project && (
        <motion.div
          className="ParticularProject_Page"
          variants={pageTransitions}
          initial="hidden"
          animate="visible"
          exit="exit"
        >
          <div
            className="ParticularProject_Page__page-content Scrollable"
            onScroll={handleScroll}
          >
            <motion.div
              className="ParticularProject_Page__page-content__Title"
              variants={fadeinslow}
              initial="hidden"
              animate="visible"
            >
              <div
                className="ParticularProject_Page__page-content__Title-backButton"
                onClick={() => history.push('/projects')}
              >
                <img src={backButton} />
              </div>
              <div className="ParticularProject_Page__page-content__Title-heading">
                {project.name}
              </div>
            </motion.div>

            <motion.div className="ParticularProject_Page__page-content__Video">
              <Carousel showThumbs={false} autoPlay infiniteLoop>
                {project.images ? (
                  project.images.map((data) => (
                    <img src={data.image} style={{ height: '40vw' }} />
                  ))
                ) : (
                  <>
                    <img src={project.img} style={{ height: '40vw' }} />
                  </>
                )}
              </Carousel>
            </motion.div>
            <motion.div className="ParticularProject_Page__page-content__project-details">
              <div className="ParticularProject_Page__page-content__project-details__links">
                <a href={project.demo}>
                  <img src={demo} />
                </a>
                <a href={project.github}>
                  <img src={github} />
                </a>
              </div>
              <div className="ParticularProject_Page__page-content__project-details__tech">
                {project.tech.map((tech) => (
                  <div>{tech}</div>
                ))}
              </div>
            </motion.div>
            <motion.div className="ParticularProject_Page__page-content__desc margin-bottom-big">
              <div dangerouslySetInnerHTML={{ __html: project.desc }}></div>
            </motion.div>
          </div>
        </motion.div>
      )}
    </>
  );
};
export default ParticularProject;
